/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TimeRouteImport } from './routes/time'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ProjectsRouteImport } from './routes/projects'
import { Route as PlaceholderRouteImport } from './routes/placeholder'
import { Route as PeopleRouteImport } from './routes/people'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InventoryRouteImport } from './routes/inventory'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as BoardsRouteImport } from './routes/boards'
import { Route as AiRouteImport } from './routes/ai'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AbsencesIndexRouteImport } from './routes/absences.index'
import { Route as SettingsRolesRouteImport } from './routes/settings.roles'
import { Route as SettingsPreboardingFormsRouteImport } from './routes/settings.preboarding-forms'
import { Route as SettingsPositionsRouteImport } from './routes/settings.positions'
import { Route as SettingsNotificationsRouteImport } from './routes/settings.notifications'
import { Route as SettingsIntegrationsRouteImport } from './routes/settings.integrations'
import { Route as SettingsImportRouteImport } from './routes/settings.import'
import { Route as SettingsExportRouteImport } from './routes/settings.export'
import { Route as SettingsEmploymentTypesRouteImport } from './routes/settings.employment-types'
import { Route as SettingsCustomizationRouteImport } from './routes/settings.customization'
import { Route as SettingsChangelogRouteImport } from './routes/settings.changelog'
import { Route as SettingsAssetTypesRouteImport } from './routes/settings.asset-types'
import { Route as SettingsAiRouteImport } from './routes/settings.ai'
import { Route as SettingsAccessTypesRouteImport } from './routes/settings.access-types'
import { Route as SettingsAbsenceTypesRouteImport } from './routes/settings.absence-types'
import { Route as SettingsSectionRouteImport } from './routes/settings.$section'
import { Route as RecruitmentVacanciesRouteImport } from './routes/recruitment.vacancies'
import { Route as RecruitmentCandidatesRouteImport } from './routes/recruitment.candidates'
import { Route as ProjectsIdRouteImport } from './routes/projects.$id'
import { Route as PreboardingTokenRouteImport } from './routes/preboarding.$token'
import { Route as EmployeesIdRouteImport } from './routes/employees.$id'
import { Route as ConsentTokenRouteImport } from './routes/consent.$token'
import { Route as CareersSlugRouteImport } from './routes/careers.$slug'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AbsencesScheduleRouteImport } from './routes/absences.schedule'
import { Route as AbsencesRequestRouteImport } from './routes/absences.request'
import { Route as AbsencesCalendarRouteImport } from './routes/absences.calendar'
import { Route as AbsencesBalancesRouteImport } from './routes/absences.balances'
import { Route as SettingsPreboardingFormsIdRouteImport } from './routes/settings.preboarding-forms.$id'
import { Route as SettingsIntegrationsPeopleforceRouteImport } from './routes/settings.integrations.peopleforce'
import { Route as SettingsIntegrationsJiraRouteImport } from './routes/settings.integrations.jira'
import { Route as SettingsIntegrationsClockifyRouteImport } from './routes/settings.integrations.clockify'
import { Route as SettingsIntegrationsIdRouteImport } from './routes/settings.integrations.$id'
import { Route as RecruitmentVacanciesIdRouteImport } from './routes/recruitment.vacancies_.$id'
import { Route as RecruitmentCandidatesIdRouteImport } from './routes/recruitment.candidates_.$id'
import { Route as RecruitmentCandidatesIdIndexRouteImport } from './routes/recruitment.candidates_.$id.index'
import { Route as SettingsAbsenceTypesIdConfigureRouteImport } from './routes/settings.absence-types.$id.configure'
import { Route as RecruitmentCandidatesIdVacanciesRouteImport } from './routes/recruitment.candidates_.$id.vacancies'
import { Route as RecruitmentCandidatesIdProfileRouteImport } from './routes/recruitment.candidates_.$id.profile'
import { Route as RecruitmentCandidatesIdNotesRouteImport } from './routes/recruitment.candidates_.$id.notes'
import { Route as RecruitmentCandidatesIdInterviewRouteImport } from './routes/recruitment.candidates_.$id.interview'
import { Route as RecruitmentCandidatesIdGdprRouteImport } from './routes/recruitment.candidates_.$id.gdpr'
import { Route as RecruitmentCandidatesIdFilesRouteImport } from './routes/recruitment.candidates_.$id.files'
import { Route as RecruitmentCandidatesIdAuditRouteImport } from './routes/recruitment.candidates_.$id.audit'

const TimeRoute = TimeRouteImport.update({
  id: '/time',
  path: '/time',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsRoute = ProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const PlaceholderRoute = PlaceholderRouteImport.update({
  id: '/placeholder',
  path: '/placeholder',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleRoute = PeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryRoute = InventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const BoardsRoute = BoardsRouteImport.update({
  id: '/boards',
  path: '/boards',
  getParentRoute: () => rootRouteImport,
} as any)
const AiRoute = AiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AbsencesIndexRoute = AbsencesIndexRouteImport.update({
  id: '/absences/',
  path: '/absences/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRolesRoute = SettingsRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsPreboardingFormsRoute =
  SettingsPreboardingFormsRouteImport.update({
    id: '/preboarding-forms',
    path: '/preboarding-forms',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsPositionsRoute = SettingsPositionsRouteImport.update({
  id: '/positions',
  path: '/positions',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsIntegrationsRoute = SettingsIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsImportRoute = SettingsImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsExportRoute = SettingsExportRouteImport.update({
  id: '/export',
  path: '/export',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsEmploymentTypesRoute = SettingsEmploymentTypesRouteImport.update({
  id: '/employment-types',
  path: '/employment-types',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsCustomizationRoute = SettingsCustomizationRouteImport.update({
  id: '/customization',
  path: '/customization',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsChangelogRoute = SettingsChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAssetTypesRoute = SettingsAssetTypesRouteImport.update({
  id: '/asset-types',
  path: '/asset-types',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAiRoute = SettingsAiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAccessTypesRoute = SettingsAccessTypesRouteImport.update({
  id: '/access-types',
  path: '/access-types',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAbsenceTypesRoute = SettingsAbsenceTypesRouteImport.update({
  id: '/absence-types',
  path: '/absence-types',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSectionRoute = SettingsSectionRouteImport.update({
  id: '/$section',
  path: '/$section',
  getParentRoute: () => SettingsRoute,
} as any)
const RecruitmentVacanciesRoute = RecruitmentVacanciesRouteImport.update({
  id: '/recruitment/vacancies',
  path: '/recruitment/vacancies',
  getParentRoute: () => rootRouteImport,
} as any)
const RecruitmentCandidatesRoute = RecruitmentCandidatesRouteImport.update({
  id: '/recruitment/candidates',
  path: '/recruitment/candidates',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIdRoute = ProjectsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ProjectsRoute,
} as any)
const PreboardingTokenRoute = PreboardingTokenRouteImport.update({
  id: '/preboarding/$token',
  path: '/preboarding/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployeesIdRoute = EmployeesIdRouteImport.update({
  id: '/employees/$id',
  path: '/employees/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsentTokenRoute = ConsentTokenRouteImport.update({
  id: '/consent/$token',
  path: '/consent/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const CareersSlugRoute = CareersSlugRouteImport.update({
  id: '/careers/$slug',
  path: '/careers/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AbsencesScheduleRoute = AbsencesScheduleRouteImport.update({
  id: '/absences/schedule',
  path: '/absences/schedule',
  getParentRoute: () => rootRouteImport,
} as any)
const AbsencesRequestRoute = AbsencesRequestRouteImport.update({
  id: '/absences/request',
  path: '/absences/request',
  getParentRoute: () => rootRouteImport,
} as any)
const AbsencesCalendarRoute = AbsencesCalendarRouteImport.update({
  id: '/absences/calendar',
  path: '/absences/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const AbsencesBalancesRoute = AbsencesBalancesRouteImport.update({
  id: '/absences/balances',
  path: '/absences/balances',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsPreboardingFormsIdRoute =
  SettingsPreboardingFormsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => SettingsPreboardingFormsRoute,
  } as any)
const SettingsIntegrationsPeopleforceRoute =
  SettingsIntegrationsPeopleforceRouteImport.update({
    id: '/peopleforce',
    path: '/peopleforce',
    getParentRoute: () => SettingsIntegrationsRoute,
  } as any)
const SettingsIntegrationsJiraRoute =
  SettingsIntegrationsJiraRouteImport.update({
    id: '/jira',
    path: '/jira',
    getParentRoute: () => SettingsIntegrationsRoute,
  } as any)
const SettingsIntegrationsClockifyRoute =
  SettingsIntegrationsClockifyRouteImport.update({
    id: '/clockify',
    path: '/clockify',
    getParentRoute: () => SettingsIntegrationsRoute,
  } as any)
const SettingsIntegrationsIdRoute = SettingsIntegrationsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => SettingsIntegrationsRoute,
} as any)
const RecruitmentVacanciesIdRoute = RecruitmentVacanciesIdRouteImport.update({
  id: '/recruitment/vacancies_/$id',
  path: '/recruitment/vacancies/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const RecruitmentCandidatesIdRoute = RecruitmentCandidatesIdRouteImport.update({
  id: '/recruitment/candidates_/$id',
  path: '/recruitment/candidates/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const RecruitmentCandidatesIdIndexRoute =
  RecruitmentCandidatesIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => RecruitmentCandidatesIdRoute,
  } as any)
const SettingsAbsenceTypesIdConfigureRoute =
  SettingsAbsenceTypesIdConfigureRouteImport.update({
    id: '/$id/configure',
    path: '/$id/configure',
    getParentRoute: () => SettingsAbsenceTypesRoute,
  } as any)
const RecruitmentCandidatesIdVacanciesRoute =
  RecruitmentCandidatesIdVacanciesRouteImport.update({
    id: '/vacancies',
    path: '/vacancies',
    getParentRoute: () => RecruitmentCandidatesIdRoute,
  } as any)
const RecruitmentCandidatesIdProfileRoute =
  RecruitmentCandidatesIdProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => RecruitmentCandidatesIdRoute,
  } as any)
const RecruitmentCandidatesIdNotesRoute =
  RecruitmentCandidatesIdNotesRouteImport.update({
    id: '/notes',
    path: '/notes',
    getParentRoute: () => RecruitmentCandidatesIdRoute,
  } as any)
const RecruitmentCandidatesIdInterviewRoute =
  RecruitmentCandidatesIdInterviewRouteImport.update({
    id: '/interview',
    path: '/interview',
    getParentRoute: () => RecruitmentCandidatesIdRoute,
  } as any)
const RecruitmentCandidatesIdGdprRoute =
  RecruitmentCandidatesIdGdprRouteImport.update({
    id: '/gdpr',
    path: '/gdpr',
    getParentRoute: () => RecruitmentCandidatesIdRoute,
  } as any)
const RecruitmentCandidatesIdFilesRoute =
  RecruitmentCandidatesIdFilesRouteImport.update({
    id: '/files',
    path: '/files',
    getParentRoute: () => RecruitmentCandidatesIdRoute,
  } as any)
const RecruitmentCandidatesIdAuditRoute =
  RecruitmentCandidatesIdAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => RecruitmentCandidatesIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/ai': typeof AiRoute
  '/boards': typeof BoardsRoute
  '/dashboard': typeof DashboardRoute
  '/inventory': typeof InventoryRoute
  '/login': typeof LoginRoute
  '/people': typeof PeopleRoute
  '/placeholder': typeof PlaceholderRoute
  '/projects': typeof ProjectsRouteWithChildren
  '/settings': typeof SettingsRouteWithChildren
  '/time': typeof TimeRoute
  '/absences/balances': typeof AbsencesBalancesRoute
  '/absences/calendar': typeof AbsencesCalendarRoute
  '/absences/request': typeof AbsencesRequestRoute
  '/absences/schedule': typeof AbsencesScheduleRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/careers/$slug': typeof CareersSlugRoute
  '/consent/$token': typeof ConsentTokenRoute
  '/employees/$id': typeof EmployeesIdRoute
  '/preboarding/$token': typeof PreboardingTokenRoute
  '/projects/$id': typeof ProjectsIdRoute
  '/recruitment/candidates': typeof RecruitmentCandidatesRoute
  '/recruitment/vacancies': typeof RecruitmentVacanciesRoute
  '/settings/$section': typeof SettingsSectionRoute
  '/settings/absence-types': typeof SettingsAbsenceTypesRouteWithChildren
  '/settings/access-types': typeof SettingsAccessTypesRoute
  '/settings/ai': typeof SettingsAiRoute
  '/settings/asset-types': typeof SettingsAssetTypesRoute
  '/settings/changelog': typeof SettingsChangelogRoute
  '/settings/customization': typeof SettingsCustomizationRoute
  '/settings/employment-types': typeof SettingsEmploymentTypesRoute
  '/settings/export': typeof SettingsExportRoute
  '/settings/import': typeof SettingsImportRoute
  '/settings/integrations': typeof SettingsIntegrationsRouteWithChildren
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/positions': typeof SettingsPositionsRoute
  '/settings/preboarding-forms': typeof SettingsPreboardingFormsRouteWithChildren
  '/settings/roles': typeof SettingsRolesRoute
  '/absences': typeof AbsencesIndexRoute
  '/recruitment/candidates/$id': typeof RecruitmentCandidatesIdRouteWithChildren
  '/recruitment/vacancies/$id': typeof RecruitmentVacanciesIdRoute
  '/settings/integrations/$id': typeof SettingsIntegrationsIdRoute
  '/settings/integrations/clockify': typeof SettingsIntegrationsClockifyRoute
  '/settings/integrations/jira': typeof SettingsIntegrationsJiraRoute
  '/settings/integrations/peopleforce': typeof SettingsIntegrationsPeopleforceRoute
  '/settings/preboarding-forms/$id': typeof SettingsPreboardingFormsIdRoute
  '/recruitment/candidates/$id/audit': typeof RecruitmentCandidatesIdAuditRoute
  '/recruitment/candidates/$id/files': typeof RecruitmentCandidatesIdFilesRoute
  '/recruitment/candidates/$id/gdpr': typeof RecruitmentCandidatesIdGdprRoute
  '/recruitment/candidates/$id/interview': typeof RecruitmentCandidatesIdInterviewRoute
  '/recruitment/candidates/$id/notes': typeof RecruitmentCandidatesIdNotesRoute
  '/recruitment/candidates/$id/profile': typeof RecruitmentCandidatesIdProfileRoute
  '/recruitment/candidates/$id/vacancies': typeof RecruitmentCandidatesIdVacanciesRoute
  '/settings/absence-types/$id/configure': typeof SettingsAbsenceTypesIdConfigureRoute
  '/recruitment/candidates/$id/': typeof RecruitmentCandidatesIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/ai': typeof AiRoute
  '/boards': typeof BoardsRoute
  '/dashboard': typeof DashboardRoute
  '/inventory': typeof InventoryRoute
  '/login': typeof LoginRoute
  '/people': typeof PeopleRoute
  '/placeholder': typeof PlaceholderRoute
  '/projects': typeof ProjectsRouteWithChildren
  '/settings': typeof SettingsRouteWithChildren
  '/time': typeof TimeRoute
  '/absences/balances': typeof AbsencesBalancesRoute
  '/absences/calendar': typeof AbsencesCalendarRoute
  '/absences/request': typeof AbsencesRequestRoute
  '/absences/schedule': typeof AbsencesScheduleRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/careers/$slug': typeof CareersSlugRoute
  '/consent/$token': typeof ConsentTokenRoute
  '/employees/$id': typeof EmployeesIdRoute
  '/preboarding/$token': typeof PreboardingTokenRoute
  '/projects/$id': typeof ProjectsIdRoute
  '/recruitment/candidates': typeof RecruitmentCandidatesRoute
  '/recruitment/vacancies': typeof RecruitmentVacanciesRoute
  '/settings/$section': typeof SettingsSectionRoute
  '/settings/absence-types': typeof SettingsAbsenceTypesRouteWithChildren
  '/settings/access-types': typeof SettingsAccessTypesRoute
  '/settings/ai': typeof SettingsAiRoute
  '/settings/asset-types': typeof SettingsAssetTypesRoute
  '/settings/changelog': typeof SettingsChangelogRoute
  '/settings/customization': typeof SettingsCustomizationRoute
  '/settings/employment-types': typeof SettingsEmploymentTypesRoute
  '/settings/export': typeof SettingsExportRoute
  '/settings/import': typeof SettingsImportRoute
  '/settings/integrations': typeof SettingsIntegrationsRouteWithChildren
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/positions': typeof SettingsPositionsRoute
  '/settings/preboarding-forms': typeof SettingsPreboardingFormsRouteWithChildren
  '/settings/roles': typeof SettingsRolesRoute
  '/absences': typeof AbsencesIndexRoute
  '/recruitment/vacancies/$id': typeof RecruitmentVacanciesIdRoute
  '/settings/integrations/$id': typeof SettingsIntegrationsIdRoute
  '/settings/integrations/clockify': typeof SettingsIntegrationsClockifyRoute
  '/settings/integrations/jira': typeof SettingsIntegrationsJiraRoute
  '/settings/integrations/peopleforce': typeof SettingsIntegrationsPeopleforceRoute
  '/settings/preboarding-forms/$id': typeof SettingsPreboardingFormsIdRoute
  '/recruitment/candidates/$id/audit': typeof RecruitmentCandidatesIdAuditRoute
  '/recruitment/candidates/$id/files': typeof RecruitmentCandidatesIdFilesRoute
  '/recruitment/candidates/$id/gdpr': typeof RecruitmentCandidatesIdGdprRoute
  '/recruitment/candidates/$id/interview': typeof RecruitmentCandidatesIdInterviewRoute
  '/recruitment/candidates/$id/notes': typeof RecruitmentCandidatesIdNotesRoute
  '/recruitment/candidates/$id/profile': typeof RecruitmentCandidatesIdProfileRoute
  '/recruitment/candidates/$id/vacancies': typeof RecruitmentCandidatesIdVacanciesRoute
  '/settings/absence-types/$id/configure': typeof SettingsAbsenceTypesIdConfigureRoute
  '/recruitment/candidates/$id': typeof RecruitmentCandidatesIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/ai': typeof AiRoute
  '/boards': typeof BoardsRoute
  '/dashboard': typeof DashboardRoute
  '/inventory': typeof InventoryRoute
  '/login': typeof LoginRoute
  '/people': typeof PeopleRoute
  '/placeholder': typeof PlaceholderRoute
  '/projects': typeof ProjectsRouteWithChildren
  '/settings': typeof SettingsRouteWithChildren
  '/time': typeof TimeRoute
  '/absences/balances': typeof AbsencesBalancesRoute
  '/absences/calendar': typeof AbsencesCalendarRoute
  '/absences/request': typeof AbsencesRequestRoute
  '/absences/schedule': typeof AbsencesScheduleRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/careers/$slug': typeof CareersSlugRoute
  '/consent/$token': typeof ConsentTokenRoute
  '/employees/$id': typeof EmployeesIdRoute
  '/preboarding/$token': typeof PreboardingTokenRoute
  '/projects/$id': typeof ProjectsIdRoute
  '/recruitment/candidates': typeof RecruitmentCandidatesRoute
  '/recruitment/vacancies': typeof RecruitmentVacanciesRoute
  '/settings/$section': typeof SettingsSectionRoute
  '/settings/absence-types': typeof SettingsAbsenceTypesRouteWithChildren
  '/settings/access-types': typeof SettingsAccessTypesRoute
  '/settings/ai': typeof SettingsAiRoute
  '/settings/asset-types': typeof SettingsAssetTypesRoute
  '/settings/changelog': typeof SettingsChangelogRoute
  '/settings/customization': typeof SettingsCustomizationRoute
  '/settings/employment-types': typeof SettingsEmploymentTypesRoute
  '/settings/export': typeof SettingsExportRoute
  '/settings/import': typeof SettingsImportRoute
  '/settings/integrations': typeof SettingsIntegrationsRouteWithChildren
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/positions': typeof SettingsPositionsRoute
  '/settings/preboarding-forms': typeof SettingsPreboardingFormsRouteWithChildren
  '/settings/roles': typeof SettingsRolesRoute
  '/absences/': typeof AbsencesIndexRoute
  '/recruitment/candidates_/$id': typeof RecruitmentCandidatesIdRouteWithChildren
  '/recruitment/vacancies_/$id': typeof RecruitmentVacanciesIdRoute
  '/settings/integrations/$id': typeof SettingsIntegrationsIdRoute
  '/settings/integrations/clockify': typeof SettingsIntegrationsClockifyRoute
  '/settings/integrations/jira': typeof SettingsIntegrationsJiraRoute
  '/settings/integrations/peopleforce': typeof SettingsIntegrationsPeopleforceRoute
  '/settings/preboarding-forms/$id': typeof SettingsPreboardingFormsIdRoute
  '/recruitment/candidates_/$id/audit': typeof RecruitmentCandidatesIdAuditRoute
  '/recruitment/candidates_/$id/files': typeof RecruitmentCandidatesIdFilesRoute
  '/recruitment/candidates_/$id/gdpr': typeof RecruitmentCandidatesIdGdprRoute
  '/recruitment/candidates_/$id/interview': typeof RecruitmentCandidatesIdInterviewRoute
  '/recruitment/candidates_/$id/notes': typeof RecruitmentCandidatesIdNotesRoute
  '/recruitment/candidates_/$id/profile': typeof RecruitmentCandidatesIdProfileRoute
  '/recruitment/candidates_/$id/vacancies': typeof RecruitmentCandidatesIdVacanciesRoute
  '/settings/absence-types/$id/configure': typeof SettingsAbsenceTypesIdConfigureRoute
  '/recruitment/candidates_/$id/': typeof RecruitmentCandidatesIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ai'
    | '/boards'
    | '/dashboard'
    | '/inventory'
    | '/login'
    | '/people'
    | '/placeholder'
    | '/projects'
    | '/settings'
    | '/time'
    | '/absences/balances'
    | '/absences/calendar'
    | '/absences/request'
    | '/absences/schedule'
    | '/auth/callback'
    | '/careers/$slug'
    | '/consent/$token'
    | '/employees/$id'
    | '/preboarding/$token'
    | '/projects/$id'
    | '/recruitment/candidates'
    | '/recruitment/vacancies'
    | '/settings/$section'
    | '/settings/absence-types'
    | '/settings/access-types'
    | '/settings/ai'
    | '/settings/asset-types'
    | '/settings/changelog'
    | '/settings/customization'
    | '/settings/employment-types'
    | '/settings/export'
    | '/settings/import'
    | '/settings/integrations'
    | '/settings/notifications'
    | '/settings/positions'
    | '/settings/preboarding-forms'
    | '/settings/roles'
    | '/absences'
    | '/recruitment/candidates/$id'
    | '/recruitment/vacancies/$id'
    | '/settings/integrations/$id'
    | '/settings/integrations/clockify'
    | '/settings/integrations/jira'
    | '/settings/integrations/peopleforce'
    | '/settings/preboarding-forms/$id'
    | '/recruitment/candidates/$id/audit'
    | '/recruitment/candidates/$id/files'
    | '/recruitment/candidates/$id/gdpr'
    | '/recruitment/candidates/$id/interview'
    | '/recruitment/candidates/$id/notes'
    | '/recruitment/candidates/$id/profile'
    | '/recruitment/candidates/$id/vacancies'
    | '/settings/absence-types/$id/configure'
    | '/recruitment/candidates/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ai'
    | '/boards'
    | '/dashboard'
    | '/inventory'
    | '/login'
    | '/people'
    | '/placeholder'
    | '/projects'
    | '/settings'
    | '/time'
    | '/absences/balances'
    | '/absences/calendar'
    | '/absences/request'
    | '/absences/schedule'
    | '/auth/callback'
    | '/careers/$slug'
    | '/consent/$token'
    | '/employees/$id'
    | '/preboarding/$token'
    | '/projects/$id'
    | '/recruitment/candidates'
    | '/recruitment/vacancies'
    | '/settings/$section'
    | '/settings/absence-types'
    | '/settings/access-types'
    | '/settings/ai'
    | '/settings/asset-types'
    | '/settings/changelog'
    | '/settings/customization'
    | '/settings/employment-types'
    | '/settings/export'
    | '/settings/import'
    | '/settings/integrations'
    | '/settings/notifications'
    | '/settings/positions'
    | '/settings/preboarding-forms'
    | '/settings/roles'
    | '/absences'
    | '/recruitment/vacancies/$id'
    | '/settings/integrations/$id'
    | '/settings/integrations/clockify'
    | '/settings/integrations/jira'
    | '/settings/integrations/peopleforce'
    | '/settings/preboarding-forms/$id'
    | '/recruitment/candidates/$id/audit'
    | '/recruitment/candidates/$id/files'
    | '/recruitment/candidates/$id/gdpr'
    | '/recruitment/candidates/$id/interview'
    | '/recruitment/candidates/$id/notes'
    | '/recruitment/candidates/$id/profile'
    | '/recruitment/candidates/$id/vacancies'
    | '/settings/absence-types/$id/configure'
    | '/recruitment/candidates/$id'
  id:
    | '__root__'
    | '/'
    | '/ai'
    | '/boards'
    | '/dashboard'
    | '/inventory'
    | '/login'
    | '/people'
    | '/placeholder'
    | '/projects'
    | '/settings'
    | '/time'
    | '/absences/balances'
    | '/absences/calendar'
    | '/absences/request'
    | '/absences/schedule'
    | '/auth/callback'
    | '/careers/$slug'
    | '/consent/$token'
    | '/employees/$id'
    | '/preboarding/$token'
    | '/projects/$id'
    | '/recruitment/candidates'
    | '/recruitment/vacancies'
    | '/settings/$section'
    | '/settings/absence-types'
    | '/settings/access-types'
    | '/settings/ai'
    | '/settings/asset-types'
    | '/settings/changelog'
    | '/settings/customization'
    | '/settings/employment-types'
    | '/settings/export'
    | '/settings/import'
    | '/settings/integrations'
    | '/settings/notifications'
    | '/settings/positions'
    | '/settings/preboarding-forms'
    | '/settings/roles'
    | '/absences/'
    | '/recruitment/candidates_/$id'
    | '/recruitment/vacancies_/$id'
    | '/settings/integrations/$id'
    | '/settings/integrations/clockify'
    | '/settings/integrations/jira'
    | '/settings/integrations/peopleforce'
    | '/settings/preboarding-forms/$id'
    | '/recruitment/candidates_/$id/audit'
    | '/recruitment/candidates_/$id/files'
    | '/recruitment/candidates_/$id/gdpr'
    | '/recruitment/candidates_/$id/interview'
    | '/recruitment/candidates_/$id/notes'
    | '/recruitment/candidates_/$id/profile'
    | '/recruitment/candidates_/$id/vacancies'
    | '/settings/absence-types/$id/configure'
    | '/recruitment/candidates_/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AiRoute: typeof AiRoute
  BoardsRoute: typeof BoardsRoute
  DashboardRoute: typeof DashboardRoute
  InventoryRoute: typeof InventoryRoute
  LoginRoute: typeof LoginRoute
  PeopleRoute: typeof PeopleRoute
  PlaceholderRoute: typeof PlaceholderRoute
  ProjectsRoute: typeof ProjectsRouteWithChildren
  SettingsRoute: typeof SettingsRouteWithChildren
  TimeRoute: typeof TimeRoute
  AbsencesBalancesRoute: typeof AbsencesBalancesRoute
  AbsencesCalendarRoute: typeof AbsencesCalendarRoute
  AbsencesRequestRoute: typeof AbsencesRequestRoute
  AbsencesScheduleRoute: typeof AbsencesScheduleRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  CareersSlugRoute: typeof CareersSlugRoute
  ConsentTokenRoute: typeof ConsentTokenRoute
  EmployeesIdRoute: typeof EmployeesIdRoute
  PreboardingTokenRoute: typeof PreboardingTokenRoute
  RecruitmentCandidatesRoute: typeof RecruitmentCandidatesRoute
  RecruitmentVacanciesRoute: typeof RecruitmentVacanciesRoute
  AbsencesIndexRoute: typeof AbsencesIndexRoute
  RecruitmentCandidatesIdRoute: typeof RecruitmentCandidatesIdRouteWithChildren
  RecruitmentVacanciesIdRoute: typeof RecruitmentVacanciesIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/time': {
      id: '/time'
      path: '/time'
      fullPath: '/time'
      preLoaderRoute: typeof TimeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects': {
      id: '/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/placeholder': {
      id: '/placeholder'
      path: '/placeholder'
      fullPath: '/placeholder'
      preLoaderRoute: typeof PlaceholderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people': {
      id: '/people'
      path: '/people'
      fullPath: '/people'
      preLoaderRoute: typeof PeopleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory': {
      id: '/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof InventoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/boards': {
      id: '/boards'
      path: '/boards'
      fullPath: '/boards'
      preLoaderRoute: typeof BoardsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai': {
      id: '/ai'
      path: '/ai'
      fullPath: '/ai'
      preLoaderRoute: typeof AiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/absences/': {
      id: '/absences/'
      path: '/absences'
      fullPath: '/absences'
      preLoaderRoute: typeof AbsencesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/roles': {
      id: '/settings/roles'
      path: '/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof SettingsRolesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/preboarding-forms': {
      id: '/settings/preboarding-forms'
      path: '/preboarding-forms'
      fullPath: '/settings/preboarding-forms'
      preLoaderRoute: typeof SettingsPreboardingFormsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/positions': {
      id: '/settings/positions'
      path: '/positions'
      fullPath: '/settings/positions'
      preLoaderRoute: typeof SettingsPositionsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/notifications': {
      id: '/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof SettingsNotificationsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/integrations': {
      id: '/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof SettingsIntegrationsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/import': {
      id: '/settings/import'
      path: '/import'
      fullPath: '/settings/import'
      preLoaderRoute: typeof SettingsImportRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/export': {
      id: '/settings/export'
      path: '/export'
      fullPath: '/settings/export'
      preLoaderRoute: typeof SettingsExportRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/employment-types': {
      id: '/settings/employment-types'
      path: '/employment-types'
      fullPath: '/settings/employment-types'
      preLoaderRoute: typeof SettingsEmploymentTypesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/customization': {
      id: '/settings/customization'
      path: '/customization'
      fullPath: '/settings/customization'
      preLoaderRoute: typeof SettingsCustomizationRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/changelog': {
      id: '/settings/changelog'
      path: '/changelog'
      fullPath: '/settings/changelog'
      preLoaderRoute: typeof SettingsChangelogRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/asset-types': {
      id: '/settings/asset-types'
      path: '/asset-types'
      fullPath: '/settings/asset-types'
      preLoaderRoute: typeof SettingsAssetTypesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/ai': {
      id: '/settings/ai'
      path: '/ai'
      fullPath: '/settings/ai'
      preLoaderRoute: typeof SettingsAiRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/access-types': {
      id: '/settings/access-types'
      path: '/access-types'
      fullPath: '/settings/access-types'
      preLoaderRoute: typeof SettingsAccessTypesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/absence-types': {
      id: '/settings/absence-types'
      path: '/absence-types'
      fullPath: '/settings/absence-types'
      preLoaderRoute: typeof SettingsAbsenceTypesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/$section': {
      id: '/settings/$section'
      path: '/$section'
      fullPath: '/settings/$section'
      preLoaderRoute: typeof SettingsSectionRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/recruitment/vacancies': {
      id: '/recruitment/vacancies'
      path: '/recruitment/vacancies'
      fullPath: '/recruitment/vacancies'
      preLoaderRoute: typeof RecruitmentVacanciesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recruitment/candidates': {
      id: '/recruitment/candidates'
      path: '/recruitment/candidates'
      fullPath: '/recruitment/candidates'
      preLoaderRoute: typeof RecruitmentCandidatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$id': {
      id: '/projects/$id'
      path: '/$id'
      fullPath: '/projects/$id'
      preLoaderRoute: typeof ProjectsIdRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/preboarding/$token': {
      id: '/preboarding/$token'
      path: '/preboarding/$token'
      fullPath: '/preboarding/$token'
      preLoaderRoute: typeof PreboardingTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employees/$id': {
      id: '/employees/$id'
      path: '/employees/$id'
      fullPath: '/employees/$id'
      preLoaderRoute: typeof EmployeesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/consent/$token': {
      id: '/consent/$token'
      path: '/consent/$token'
      fullPath: '/consent/$token'
      preLoaderRoute: typeof ConsentTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/careers/$slug': {
      id: '/careers/$slug'
      path: '/careers/$slug'
      fullPath: '/careers/$slug'
      preLoaderRoute: typeof CareersSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/absences/schedule': {
      id: '/absences/schedule'
      path: '/absences/schedule'
      fullPath: '/absences/schedule'
      preLoaderRoute: typeof AbsencesScheduleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/absences/request': {
      id: '/absences/request'
      path: '/absences/request'
      fullPath: '/absences/request'
      preLoaderRoute: typeof AbsencesRequestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/absences/calendar': {
      id: '/absences/calendar'
      path: '/absences/calendar'
      fullPath: '/absences/calendar'
      preLoaderRoute: typeof AbsencesCalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/absences/balances': {
      id: '/absences/balances'
      path: '/absences/balances'
      fullPath: '/absences/balances'
      preLoaderRoute: typeof AbsencesBalancesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/preboarding-forms/$id': {
      id: '/settings/preboarding-forms/$id'
      path: '/$id'
      fullPath: '/settings/preboarding-forms/$id'
      preLoaderRoute: typeof SettingsPreboardingFormsIdRouteImport
      parentRoute: typeof SettingsPreboardingFormsRoute
    }
    '/settings/integrations/peopleforce': {
      id: '/settings/integrations/peopleforce'
      path: '/peopleforce'
      fullPath: '/settings/integrations/peopleforce'
      preLoaderRoute: typeof SettingsIntegrationsPeopleforceRouteImport
      parentRoute: typeof SettingsIntegrationsRoute
    }
    '/settings/integrations/jira': {
      id: '/settings/integrations/jira'
      path: '/jira'
      fullPath: '/settings/integrations/jira'
      preLoaderRoute: typeof SettingsIntegrationsJiraRouteImport
      parentRoute: typeof SettingsIntegrationsRoute
    }
    '/settings/integrations/clockify': {
      id: '/settings/integrations/clockify'
      path: '/clockify'
      fullPath: '/settings/integrations/clockify'
      preLoaderRoute: typeof SettingsIntegrationsClockifyRouteImport
      parentRoute: typeof SettingsIntegrationsRoute
    }
    '/settings/integrations/$id': {
      id: '/settings/integrations/$id'
      path: '/$id'
      fullPath: '/settings/integrations/$id'
      preLoaderRoute: typeof SettingsIntegrationsIdRouteImport
      parentRoute: typeof SettingsIntegrationsRoute
    }
    '/recruitment/vacancies_/$id': {
      id: '/recruitment/vacancies_/$id'
      path: '/recruitment/vacancies/$id'
      fullPath: '/recruitment/vacancies/$id'
      preLoaderRoute: typeof RecruitmentVacanciesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recruitment/candidates_/$id': {
      id: '/recruitment/candidates_/$id'
      path: '/recruitment/candidates/$id'
      fullPath: '/recruitment/candidates/$id'
      preLoaderRoute: typeof RecruitmentCandidatesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recruitment/candidates_/$id/': {
      id: '/recruitment/candidates_/$id/'
      path: '/'
      fullPath: '/recruitment/candidates/$id/'
      preLoaderRoute: typeof RecruitmentCandidatesIdIndexRouteImport
      parentRoute: typeof RecruitmentCandidatesIdRoute
    }
    '/settings/absence-types/$id/configure': {
      id: '/settings/absence-types/$id/configure'
      path: '/$id/configure'
      fullPath: '/settings/absence-types/$id/configure'
      preLoaderRoute: typeof SettingsAbsenceTypesIdConfigureRouteImport
      parentRoute: typeof SettingsAbsenceTypesRoute
    }
    '/recruitment/candidates_/$id/vacancies': {
      id: '/recruitment/candidates_/$id/vacancies'
      path: '/vacancies'
      fullPath: '/recruitment/candidates/$id/vacancies'
      preLoaderRoute: typeof RecruitmentCandidatesIdVacanciesRouteImport
      parentRoute: typeof RecruitmentCandidatesIdRoute
    }
    '/recruitment/candidates_/$id/profile': {
      id: '/recruitment/candidates_/$id/profile'
      path: '/profile'
      fullPath: '/recruitment/candidates/$id/profile'
      preLoaderRoute: typeof RecruitmentCandidatesIdProfileRouteImport
      parentRoute: typeof RecruitmentCandidatesIdRoute
    }
    '/recruitment/candidates_/$id/notes': {
      id: '/recruitment/candidates_/$id/notes'
      path: '/notes'
      fullPath: '/recruitment/candidates/$id/notes'
      preLoaderRoute: typeof RecruitmentCandidatesIdNotesRouteImport
      parentRoute: typeof RecruitmentCandidatesIdRoute
    }
    '/recruitment/candidates_/$id/interview': {
      id: '/recruitment/candidates_/$id/interview'
      path: '/interview'
      fullPath: '/recruitment/candidates/$id/interview'
      preLoaderRoute: typeof RecruitmentCandidatesIdInterviewRouteImport
      parentRoute: typeof RecruitmentCandidatesIdRoute
    }
    '/recruitment/candidates_/$id/gdpr': {
      id: '/recruitment/candidates_/$id/gdpr'
      path: '/gdpr'
      fullPath: '/recruitment/candidates/$id/gdpr'
      preLoaderRoute: typeof RecruitmentCandidatesIdGdprRouteImport
      parentRoute: typeof RecruitmentCandidatesIdRoute
    }
    '/recruitment/candidates_/$id/files': {
      id: '/recruitment/candidates_/$id/files'
      path: '/files'
      fullPath: '/recruitment/candidates/$id/files'
      preLoaderRoute: typeof RecruitmentCandidatesIdFilesRouteImport
      parentRoute: typeof RecruitmentCandidatesIdRoute
    }
    '/recruitment/candidates_/$id/audit': {
      id: '/recruitment/candidates_/$id/audit'
      path: '/audit'
      fullPath: '/recruitment/candidates/$id/audit'
      preLoaderRoute: typeof RecruitmentCandidatesIdAuditRouteImport
      parentRoute: typeof RecruitmentCandidatesIdRoute
    }
  }
}

interface ProjectsRouteChildren {
  ProjectsIdRoute: typeof ProjectsIdRoute
}

const ProjectsRouteChildren: ProjectsRouteChildren = {
  ProjectsIdRoute: ProjectsIdRoute,
}

const ProjectsRouteWithChildren = ProjectsRoute._addFileChildren(
  ProjectsRouteChildren,
)

interface SettingsAbsenceTypesRouteChildren {
  SettingsAbsenceTypesIdConfigureRoute: typeof SettingsAbsenceTypesIdConfigureRoute
}

const SettingsAbsenceTypesRouteChildren: SettingsAbsenceTypesRouteChildren = {
  SettingsAbsenceTypesIdConfigureRoute: SettingsAbsenceTypesIdConfigureRoute,
}

const SettingsAbsenceTypesRouteWithChildren =
  SettingsAbsenceTypesRoute._addFileChildren(SettingsAbsenceTypesRouteChildren)

interface SettingsIntegrationsRouteChildren {
  SettingsIntegrationsIdRoute: typeof SettingsIntegrationsIdRoute
  SettingsIntegrationsClockifyRoute: typeof SettingsIntegrationsClockifyRoute
  SettingsIntegrationsJiraRoute: typeof SettingsIntegrationsJiraRoute
  SettingsIntegrationsPeopleforceRoute: typeof SettingsIntegrationsPeopleforceRoute
}

const SettingsIntegrationsRouteChildren: SettingsIntegrationsRouteChildren = {
  SettingsIntegrationsIdRoute: SettingsIntegrationsIdRoute,
  SettingsIntegrationsClockifyRoute: SettingsIntegrationsClockifyRoute,
  SettingsIntegrationsJiraRoute: SettingsIntegrationsJiraRoute,
  SettingsIntegrationsPeopleforceRoute: SettingsIntegrationsPeopleforceRoute,
}

const SettingsIntegrationsRouteWithChildren =
  SettingsIntegrationsRoute._addFileChildren(SettingsIntegrationsRouteChildren)

interface SettingsPreboardingFormsRouteChildren {
  SettingsPreboardingFormsIdRoute: typeof SettingsPreboardingFormsIdRoute
}

const SettingsPreboardingFormsRouteChildren: SettingsPreboardingFormsRouteChildren =
  {
    SettingsPreboardingFormsIdRoute: SettingsPreboardingFormsIdRoute,
  }

const SettingsPreboardingFormsRouteWithChildren =
  SettingsPreboardingFormsRoute._addFileChildren(
    SettingsPreboardingFormsRouteChildren,
  )

interface SettingsRouteChildren {
  SettingsSectionRoute: typeof SettingsSectionRoute
  SettingsAbsenceTypesRoute: typeof SettingsAbsenceTypesRouteWithChildren
  SettingsAccessTypesRoute: typeof SettingsAccessTypesRoute
  SettingsAiRoute: typeof SettingsAiRoute
  SettingsAssetTypesRoute: typeof SettingsAssetTypesRoute
  SettingsChangelogRoute: typeof SettingsChangelogRoute
  SettingsCustomizationRoute: typeof SettingsCustomizationRoute
  SettingsEmploymentTypesRoute: typeof SettingsEmploymentTypesRoute
  SettingsExportRoute: typeof SettingsExportRoute
  SettingsImportRoute: typeof SettingsImportRoute
  SettingsIntegrationsRoute: typeof SettingsIntegrationsRouteWithChildren
  SettingsNotificationsRoute: typeof SettingsNotificationsRoute
  SettingsPositionsRoute: typeof SettingsPositionsRoute
  SettingsPreboardingFormsRoute: typeof SettingsPreboardingFormsRouteWithChildren
  SettingsRolesRoute: typeof SettingsRolesRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsSectionRoute: SettingsSectionRoute,
  SettingsAbsenceTypesRoute: SettingsAbsenceTypesRouteWithChildren,
  SettingsAccessTypesRoute: SettingsAccessTypesRoute,
  SettingsAiRoute: SettingsAiRoute,
  SettingsAssetTypesRoute: SettingsAssetTypesRoute,
  SettingsChangelogRoute: SettingsChangelogRoute,
  SettingsCustomizationRoute: SettingsCustomizationRoute,
  SettingsEmploymentTypesRoute: SettingsEmploymentTypesRoute,
  SettingsExportRoute: SettingsExportRoute,
  SettingsImportRoute: SettingsImportRoute,
  SettingsIntegrationsRoute: SettingsIntegrationsRouteWithChildren,
  SettingsNotificationsRoute: SettingsNotificationsRoute,
  SettingsPositionsRoute: SettingsPositionsRoute,
  SettingsPreboardingFormsRoute: SettingsPreboardingFormsRouteWithChildren,
  SettingsRolesRoute: SettingsRolesRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

interface RecruitmentCandidatesIdRouteChildren {
  RecruitmentCandidatesIdAuditRoute: typeof RecruitmentCandidatesIdAuditRoute
  RecruitmentCandidatesIdFilesRoute: typeof RecruitmentCandidatesIdFilesRoute
  RecruitmentCandidatesIdGdprRoute: typeof RecruitmentCandidatesIdGdprRoute
  RecruitmentCandidatesIdInterviewRoute: typeof RecruitmentCandidatesIdInterviewRoute
  RecruitmentCandidatesIdNotesRoute: typeof RecruitmentCandidatesIdNotesRoute
  RecruitmentCandidatesIdProfileRoute: typeof RecruitmentCandidatesIdProfileRoute
  RecruitmentCandidatesIdVacanciesRoute: typeof RecruitmentCandidatesIdVacanciesRoute
  RecruitmentCandidatesIdIndexRoute: typeof RecruitmentCandidatesIdIndexRoute
}

const RecruitmentCandidatesIdRouteChildren: RecruitmentCandidatesIdRouteChildren =
  {
    RecruitmentCandidatesIdAuditRoute: RecruitmentCandidatesIdAuditRoute,
    RecruitmentCandidatesIdFilesRoute: RecruitmentCandidatesIdFilesRoute,
    RecruitmentCandidatesIdGdprRoute: RecruitmentCandidatesIdGdprRoute,
    RecruitmentCandidatesIdInterviewRoute:
      RecruitmentCandidatesIdInterviewRoute,
    RecruitmentCandidatesIdNotesRoute: RecruitmentCandidatesIdNotesRoute,
    RecruitmentCandidatesIdProfileRoute: RecruitmentCandidatesIdProfileRoute,
    RecruitmentCandidatesIdVacanciesRoute:
      RecruitmentCandidatesIdVacanciesRoute,
    RecruitmentCandidatesIdIndexRoute: RecruitmentCandidatesIdIndexRoute,
  }

const RecruitmentCandidatesIdRouteWithChildren =
  RecruitmentCandidatesIdRoute._addFileChildren(
    RecruitmentCandidatesIdRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AiRoute: AiRoute,
  BoardsRoute: BoardsRoute,
  DashboardRoute: DashboardRoute,
  InventoryRoute: InventoryRoute,
  LoginRoute: LoginRoute,
  PeopleRoute: PeopleRoute,
  PlaceholderRoute: PlaceholderRoute,
  ProjectsRoute: ProjectsRouteWithChildren,
  SettingsRoute: SettingsRouteWithChildren,
  TimeRoute: TimeRoute,
  AbsencesBalancesRoute: AbsencesBalancesRoute,
  AbsencesCalendarRoute: AbsencesCalendarRoute,
  AbsencesRequestRoute: AbsencesRequestRoute,
  AbsencesScheduleRoute: AbsencesScheduleRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  CareersSlugRoute: CareersSlugRoute,
  ConsentTokenRoute: ConsentTokenRoute,
  EmployeesIdRoute: EmployeesIdRoute,
  PreboardingTokenRoute: PreboardingTokenRoute,
  RecruitmentCandidatesRoute: RecruitmentCandidatesRoute,
  RecruitmentVacanciesRoute: RecruitmentVacanciesRoute,
  AbsencesIndexRoute: AbsencesIndexRoute,
  RecruitmentCandidatesIdRoute: RecruitmentCandidatesIdRouteWithChildren,
  RecruitmentVacanciesIdRoute: RecruitmentVacanciesIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
